const SingleCollectionCardSkeleton: React.FC = () => {
  return (
    <div className="w-full pb-2">
      <div className="grid w-full">
        <div
          aria-hidden
          className="col-start-1 -translate-y-2 translate-x-1 row-start-1 rounded-24 w-full pt-1 bg-fds-brand-light-hover"
        />
        <div
          aria-hidden
          className="col-start-1 -translate-y-1 row-start-1 rounded-20 w-full pt-1 bg-fds-brand-light"
        />
        <div className="col-start-1 z-10 row-start-1 rounded-16 fds-md:p-4 p-2 items-start mr-1 bg-fds-primary rounded-14 border border-fds-on-inverse shadow-brand-md">
          <div className="flex gap-x-2 fds-md:gap-x-4">
            <div className="relative rounded-4 overflow-hidden grow shrink-0 w-[112px] lg:w-[172px] aspect-video bg-fds-disable animate-pulse" />
            <div className="w-full flex flex-col">
              <div className="h-10 md:h-fds-52 flex flex-col gap-1.5 justify-center">
                <div className="h-4 md:h-5 w-full bg-fds-disable rounded animate-pulse" />
                <div className="h-4 md:h-5 w-2/3 bg-fds-disable rounded animate-pulse" />
              </div>
              <div className="flex items-center gap-x-3 mt-1 fds-md:mt-2">
                <div className="h-4 w-16 md:w-20 bg-fds-disable rounded animate-pulse" />
                <div className="h-4 md:block hidden bg-fds-disable w-px" />
                <div className="h-4 w-16 md:w-20 bg-fds-disable rounded animate-pulse" />
              </div>
            </div>
          </div>
          <div className="border-t flex items-center justify-between border-fds-disable mt-3.5 pt-3.5">
            <div className="h-6 w-16 md:w-20 bg-fds-disable rounded-full animate-pulse" />
            <div className="h-8 w-24 md:w-28 bg-fds-disable rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleCollectionCardSkeleton;
